import { rtLogService, MonitorEventSeverity, MonitorEventSource } from '@rammetec/core';
import { entityRegistry } from '@rammetec/data-access';
let strict = false;
const reportedMisses = new Set();
/**
 * Descriptor de uma entidade para uma regra que depende dele em runtime.
 *
 * Ausência é **anomalia**, não caso normal: em modo estrito lança; fora dele,
 * registra erro (uma vez por entidade+regra) e devolve undefined, para o app
 * do usuário não quebrar por causa de uma regra secundária.
 */
export function getDescriptorForRule(entity, rule) {
    if (entityRegistry.has(entity)) {
        return entityRegistry.get(entity);
    }
    const message = `[descriptor] "${entity}" não está registrado no entityRegistry — ` +
        `a regra "${rule}" não pode rodar.`;
    if (strict) {
        throw new Error(message);
    }
    const key = `${entity}\0${rule}`;
    if (!reportedMisses.has(key)) {
        reportedMisses.add(key);
        rtLogService.error(message, { entity, rule });
        rtLogService.dispatchMonitorEvent({
            source: MonitorEventSource.DATA_ACCESS,
            severity: MonitorEventSeverity.ERROR,
            type: 'descriptor-lookup-miss',
            payload: { entity, rule },
        });
    }
    return undefined;
}
/** Liga/desliga o modo estrito. Default: desligado. */
export function setDescriptorLookupStrict(enabled) {
    strict = enabled;
}
/** Limpa a dedup de misses — para testes. */
export function resetDescriptorLookupState() {
    reportedMisses.clear();
}
//# sourceMappingURL=descriptorLookup.js.map